import React from 'react';

const successCodeRegex = /2[0-9][0-9]/;

export const renderColorStausCode = (statusCode) => {
	const isSuccess = successCodeRegex.test(statusCode);
	return <div style={{ color: isSuccess ? 'green' : 'red' }}>{statusCode}</div>;
};
